import React, { Component } from "react";
import Session from "../session";
import ClassCodes from "../classCodes";
import List from "./List";
import Stranger from "./Stranger";

export default class UsersManager extends Component {
  render() {
    return (
      <>
        <Session />
        <ClassCodes showAdd={true} />
        <List />
        <Stranger />
      </>
    );
  }
}
